module.exports = __webpack_public_path__ + "img/challenge_submitted.e69c67f2.svg";